var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12980_22597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9H1.5V9.75H5.25V9Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.75H1.5V7.5H5.25V6.75Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.25H2.25C2.05109 5.25 1.86032 5.17098 1.71967 5.03033C1.57902 4.88968 1.5 4.69891 1.5 4.5V2.25C1.5 2.05109 1.57902 1.86032 1.71967 1.71967C1.86032 1.57902 2.05109 1.5 2.25 1.5H9.75C9.94891 1.5 10.1397 1.57902 10.2803 1.71967C10.421 1.86032 10.5 2.05109 10.5 2.25V4.5C10.5 4.69891 10.421 4.88968 10.2803 5.03033C10.1397 5.17098 9.94891 5.25 9.75 5.25ZM2.25 2.25V4.5H9.75V2.25H2.25Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.5H7.5C7.30109 10.5 7.11032 10.421 6.96967 10.2803C6.82902 10.1397 6.75 9.94891 6.75 9.75V7.5C6.75 7.30109 6.82902 7.11032 6.96967 6.96967C7.11032 6.82902 7.30109 6.75 7.5 6.75H9.75C9.94891 6.75 10.1397 6.82902 10.2803 6.96967C10.421 7.11032 10.5 7.30109 10.5 7.5V9.75C10.5 9.94891 10.421 10.1397 10.2803 10.2803C10.1397 10.421 9.94891 10.5 9.75 10.5ZM7.5 7.5V9.75H9.75V7.5H7.5Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12980_22597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.c2fd715d4f6445cedf61b0f0d3f9d20e.svg";
export { ForwardRef as ReactComponent };